export default __webpack_public_path__ + "static/media/group-avatar.ef9330ae.svg";